import BrowserStorage, { browserLocalStore, browserSessionStore } from './BrowserStorage';

export {
    browserLocalStore,
    browserSessionStore
};

export default BrowserStorage;